import { Loader2 } from "lucide-react";

/**
 * Loud inline "同步中…" indicator shown next to page titles while any data fetch is in flight.
 * 20px spinner, teal accent, pulsing label.
 */
export function SyncSpinner({ show, label = "同步中…", testid = "sync-spinner" }) {
  if (!show) return null;
  return (
    <span
      className="inline-flex items-center gap-1.5 text-xs font-mono align-middle ml-3 text-teal-700"
      data-testid={testid}
    >
      <Loader2 className="h-5 w-5 animate-spin text-teal-600" strokeWidth={2.5} />
      <span className="animate-pulse font-semibold tracking-wide">{label}</span>
    </span>
  );
}

export default SyncSpinner;
